import { Component, Input } from '@angular/core';
import { ColumnComponent, FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { GridState } from '../../models';

@Component({
  selector: 'app-grid-percentage-filter-menu',
  templateUrl: './grid-percentage-filter-menu.component.html',
  styleUrl: './grid-percentage-filter-menu.component.scss',
})
export class GridPercentageFilterMenuComponent {
  @Input()
  column!: ColumnComponent;

  @Input()
  filter!: CompositeFilterDescriptor;

  @Input()
  filterService!: FilterService;

  pctFilterService: FilterService = {
    ...this.filterService,
    filter: (descriptor: CompositeFilterDescriptor) => {
      this.percentageTransform(descriptor);
      return this.filterService.filter(descriptor);
    },
  };

  private percentageTransform(descriptor: CompositeFilterDescriptor): void {
    const field = GridState.findField(descriptor, this.column.field);
    if (field == null) return;
    field.value = field?.value ? field.value / 100 : 0;
  }
}
